"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortedDateOptions = exports.calculateRow = exports.calculateShort = exports.calculateLong = exports.calculateNet = exports.calculateGross = exports.transformGridData = exports.formatDate = exports.ClassEntryModeEnum = void 0;
var date_fns_1 = require("date-fns");
var ClassEntryModeEnum;
(function (ClassEntryModeEnum) {
    ClassEntryModeEnum["NavWeight"] = "NavWeight";
    ClassEntryModeEnum["Value"] = "Value";
})(ClassEntryModeEnum = exports.ClassEntryModeEnum || (exports.ClassEntryModeEnum = {}));
var formatDate = function (value, dateFormat) {
    if (dateFormat === void 0) { dateFormat = 'MM/dd/yyyy'; }
    if (!value) {
        return '';
    }
    return date_fns_1.format(value, dateFormat);
};
exports.formatDate = formatDate;
var sortedDateOptions = function (data) {
    return data === null || data === void 0 ? void 0 : data.sort(function (a, b) {
        return new Date(b.label).valueOf() - new Date(a.label).valueOf();
    });
};
exports.sortedDateOptions = sortedDateOptions;
var transformGridData = function (classificationDetails, ClassExposures) {
    var filteredClassifications = classificationDetails === null || classificationDetails === void 0 ? void 0 : classificationDetails.Classes.filter(function (item) {
        return item.ID < 1000000;
    });
    if (!filteredClassifications)
        return undefined;
    var transformedData = filteredClassifications.map(function (item) {
        var _a, _b, _c, _d, _e, _f, _g;
        var classesToProcess = ClassExposures === null || ClassExposures === void 0 ? void 0 : ClassExposures.ClassExposures[item.ID];
        var calculatedGross = calculateGross(Number((_a = classesToProcess === null || classesToProcess === void 0 ? void 0 : classesToProcess.Long) === null || _a === void 0 ? void 0 : _a.toFixed(3)), Number((_b = classesToProcess === null || classesToProcess === void 0 ? void 0 : classesToProcess.Short) === null || _b === void 0 ? void 0 : _b.toFixed(3)));
        var calculatedNet = calculateGross(Number((_c = classesToProcess === null || classesToProcess === void 0 ? void 0 : classesToProcess.Long) === null || _c === void 0 ? void 0 : _c.toFixed(3)), Number((_d = classesToProcess === null || classesToProcess === void 0 ? void 0 : classesToProcess.Short) === null || _d === void 0 ? void 0 : _d.toFixed(3)));
        if ((classesToProcess === null || classesToProcess === void 0 ? void 0 : classesToProcess.Gross) === undefined &&
            (classesToProcess === null || classesToProcess === void 0 ? void 0 : classesToProcess.Long) === undefined &&
            (classesToProcess === null || classesToProcess === void 0 ? void 0 : classesToProcess.Short) === undefined &&
            (classesToProcess === null || classesToProcess === void 0 ? void 0 : classesToProcess.Net) !== undefined) {
            var calculatedLong = classesToProcess === null || classesToProcess === void 0 ? void 0 : classesToProcess.Net;
            var calculatedGrossForNet = calculateGross(calculatedLong, null);
            return {
                ID: item.ID,
                Name: item.Name,
                SortOrder: item.SortOrder,
                Long: Number(calculatedLong === null || calculatedLong === void 0 ? void 0 : calculatedLong.toFixed(3)),
                Short: null,
                Gross: calculatedGrossForNet,
                Net: Number((_e = classesToProcess === null || classesToProcess === void 0 ? void 0 : classesToProcess.Net) === null || _e === void 0 ? void 0 : _e.toFixed(3)),
            };
        }
        return {
            ID: item.ID,
            Name: item.Name,
            SortOrder: item.SortOrder,
            Long: (classesToProcess === null || classesToProcess === void 0 ? void 0 : classesToProcess.Long) ? Number((_f = classesToProcess === null || classesToProcess === void 0 ? void 0 : classesToProcess.Long) === null || _f === void 0 ? void 0 : _f.toFixed(3))
                : null,
            Short: (classesToProcess === null || classesToProcess === void 0 ? void 0 : classesToProcess.Short) ? Number((_g = classesToProcess === null || classesToProcess === void 0 ? void 0 : classesToProcess.Short) === null || _g === void 0 ? void 0 : _g.toFixed(3))
                : null,
            Gross: calculatedGross,
            Net: calculatedNet,
        };
    });
    return transformedData;
};
exports.transformGridData = transformGridData;
var calculateLong = function (gross, short) {
    if (gross === null || gross === undefined || gross <= 0) {
        return null;
    }
    var calculatedValue = (gross || 0) - (short || 0);
    return calculatedValue === 0 ? null : calculatedValue;
};
exports.calculateLong = calculateLong;
var calculateShort = function (gross, long) {
    if (gross === null || gross === undefined || gross <= 0) {
        return null;
    }
    var calculatedValue = (gross || 0) - (long || 0);
    return calculatedValue === 0 ? null : calculatedValue;
};
exports.calculateShort = calculateShort;
var calculateGross = function (long, short, gross, editMode) {
    if ((gross === null || gross === undefined || gross <= 0) && editMode) {
        return null;
    }
    var calculatedValue = (long || 0) + (short || 0);
    return calculatedValue === 0 ? null : calculatedValue;
};
exports.calculateGross = calculateGross;
var calculateNet = function (long, short, gross, editMode) {
    if ((gross === null || gross === undefined || gross <= 0 || gross < short) &&
        editMode) {
        return null;
    }
    var calculatedValue = (long || 0) - (short || 0);
    return calculatedValue === 0 ? null : calculatedValue;
};
exports.calculateNet = calculateNet;
var calculateRow = function (field, row, value) {
    var valueToUpdate = Number(value);
    if (field === 'Long') {
        return {
            Long: valueToUpdate === 0 ? null : valueToUpdate,
            Short: row.Short,
            Gross: calculateGross(valueToUpdate, row.Short),
            Net: calculateNet(valueToUpdate, row.Short || 0),
        };
    }
    if (field === 'Short') {
        return {
            Long: row.Long,
            Short: valueToUpdate === 0 ? null : valueToUpdate,
            Gross: calculateGross(row.Long, valueToUpdate),
            Net: calculateNet(row.Long, valueToUpdate),
        };
    }
    if (field === 'Gross') {
        var calculatedLong = void 0;
        var calculatedShort = void 0;
        if (valueToUpdate <= 0) {
            return {
                Long: null,
                Short: null,
                Gross: null,
                Net: null,
            };
        }
        if (row.Short !== null) {
            calculatedShort = row.Short;
            calculatedLong = calculateLong(valueToUpdate, calculatedShort);
        }
        else {
            calculatedShort = calculateShort(valueToUpdate, row.Long);
            calculatedLong = calculateLong(valueToUpdate, calculatedShort);
        }
        var calculatedNet = calculateNet(calculatedLong, calculatedShort || 0, valueToUpdate, true);
        return {
            Long: calculatedLong,
            Short: calculatedShort,
            Gross: valueToUpdate,
            Net: calculatedNet,
        };
    }
    if (field === 'Net') {
        var calculatedLong = void 0;
        var calculatedShort = void 0;
        var calculatedGross = void 0;
        if (row.Short === null && row.Long !== null && row.Gross !== null) {
            calculatedShort = row.Long - valueToUpdate;
            calculatedGross = calculateGross(row.Long, calculatedShort);
            return {
                Long: row.Long,
                Short: calculatedShort,
                Gross: calculatedGross,
                Net: valueToUpdate,
            };
        }
        if (row.Long === null && row.Short === null && row.Gross === null) {
            calculatedLong = valueToUpdate;
            calculatedShort = null;
            calculatedGross = calculateGross(calculatedLong, calculatedShort);
        }
        else if (row.Short !== null) {
            calculatedLong = (valueToUpdate || 0) + row.Short;
            calculatedGross = calculatedLong + row.Short;
            calculatedShort = row.Short;
        }
        else {
            calculatedLong = calculateLong(row.Gross, row.Short);
            calculatedShort = calculateShort(row.Gross, row.Long);
            calculatedGross = calculateGross(row.Long, row.Short);
        }
        return {
            Long: calculatedLong,
            Short: calculatedShort,
            Gross: calculatedGross,
            Net: valueToUpdate,
        };
    }
    return {};
};
exports.calculateRow = calculateRow;
